"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var StyledButton = (0, styles_1.styled)(Button_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        height: theme.spacing(4),
        '.MuiButton-outlinedSizeSmall': {
            padding: theme.spacing(0.25, 0),
            lineHeight: 1.2,
        },
        '& svg': {
            transform: 'rotate(342deg)',
        },
    });
});
var ButtonPrimary = function (_a) {
    var children = _a.children, icon = _a.icon, rest = __rest(_a, ["children", "icon"]);
    return ((0, jsx_runtime_1.jsxs)(StyledButton, __assign({}, rest, { children: [icon && (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mr: 1 }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon }) })), children] })));
};
exports.default = ButtonPrimary;
